
import { DeviceTypeDescription } from "@/api/dtos/DeviceTypeDescription.schema";
import { deepClone } from "@/misc/helpers";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EditFrame from "../EditFrame.vue";
import EditActionButtons from "../EditActionButtons.vue";

@Component({
  components: {
    EditFrame,
    EditActionButtons,
  },
})
export default class TypeDescriptions extends Vue {
  @Prop({ default: [] })
  deviceTypeDescriptions!: DeviceTypeDescription[];

  @Prop({
    default: false,
  })
  hideControls!: boolean;

  @Prop()
  width!: number;

  @Prop({
    default: false,
  })
  readonly forceEditing!: boolean;

  formValidated = false;

  editedDeviceTypeDescriptions: DeviceTypeDescription[] = [];
  selectedDeviceTypeDescription: DeviceTypeDescription | null = null;

  mounted(): void {
    this.importData();

    if (this.forceEditing) {
      this.isEditing = true;
    }
  }

  @Watch("deviceTypeDescriptions")
  onDescriptionsChanged(): void {
    this.importData();
  }

  importData(): void {
    this.editedDeviceTypeDescriptions = deepClone(this.deviceTypeDescriptions);
    this.selectedDeviceTypeDescription = this.editedDeviceTypeDescriptions[0];
    if (this.editedDeviceTypeDescriptions.length === 0) {
      this.formValidated = true;
    }
  }

  get deviceTypeSelectItems(): {
    text: string;
    value: DeviceTypeDescription;
  }[] {
    return this.editedDeviceTypeDescriptions.map((deviceTypeDescription) => {
      return {
        text: deviceTypeDescription.deviceType,
        value: deviceTypeDescription,
      };
    });
  }

  $refs!: {
    editFrame: EditFrame;
  };
  isEditing = false;

  onSave(): void {
    this.$emit("save", this.selectedDeviceTypeDescription);
  }

  onSaveAll(): void {
    this.$emit("save", this.editedDeviceTypeDescriptions);
  }

  onCancel(): void {
    this.importData();
  }

  onValidChanged(value: boolean): void {
    this.$emit("valid", value);
    this.formValidated = value;
  }

  tryValidate(): boolean {
    if (this.formValidated) {
      this.onSaveAll();
      return true;
    }
    return false;
  }
}
